import store from '~/store';
import { getCatalogsByPush as getCatalogs , resetMessage, getToken} from '~/pages/MessagePush/state/action'
import config from '~/config';
let lockReconnect = false
let wsUrl = config.messagePushWss;
let ws;
let tt;

let isClosed = false;

function createWebSocket(token, userToken) {
  try {
    ws = new WebSocket(`${wsUrl}?token=${token}`);
    isClosed = false;
    init(token, userToken);
  } catch (e) {
    reconnect(token, userToken);
  }
}

function init(token,userToken) {
  ws.onclose = function () {
    if(!isClosed) {
      reconnect(token,userToken);
    }
  };
  ws.onerror = function () {
    reconnect(token, userToken);
  };
  ws.onopen = function () {
    ws.send(JSON.stringify({
      action:"verify",
      "x-auth-token":userToken
    }))
    store.dispatch(getCatalogs())
    heartCheck.start();
  };
  ws.onmessage = function (event) {
    const data = JSON.parse(event.data);
    const {code, message} = data;
    if(code === 200 && message === 'success') {
      store.dispatch(getCatalogs())
    }
    heartCheck.start();
  };
}

function reconnect(token, userToken) {
  if (lockReconnect) {
    return;
  }
  lockReconnect = true;
  tt && clearTimeout(tt);
  tt = setTimeout(function () {
    store.dispatch(getToken())
    lockReconnect = false;
  }, 20000);
}

function verify (authToken) {
  if(ws.readyState === 3)
  ws.send()
} 

function close () {
  if(!isClosed&&ws) {
    if(ws.readyState === 3) return;
    isClosed = true;
    ws.send(JSON.stringify({
      action: 'disconnect'
    }))
    store.dispatch(resetMessage());
    ws.close();
  }
}
  

let heartCheck = {
  timeout: 40000,
  timeoutObj: null,
  serverTimeoutObj: null,
  start: function () {
    const self = this;
    this.timeoutObj && clearTimeout(this.timeoutObj);
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
    this.timeoutObj = setTimeout(function () {
      ws.send(JSON.stringify({
        action:"heartbeat",  
      }));
      self.serverTimeoutObj = setTimeout(function () {
        ws.close();
      }, self.timeout);
    }, this.timeout);
  },
};


export default {
  create:  createWebSocket,
  close:  close,
  verify: verify,
}



// WEBPACK FOOTER //
// ./src/misc/messagePush.js